import { Component } from '@angular/core';

@Component({
  selector: 'app-taxonomy-playground',
  standalone: true,
  imports: [],
  templateUrl: './taxonomy-playground.component.html',
  styleUrl: './taxonomy-playground.component.scss'
})
export class TaxonomyPlaygroundComponent {

}
